import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/remote-config";
import "firebase/functions";
import "firebase/database";
import "firebase/storage";
import "firebase/analytics";
import config from "@/firebase.config";
import utils from "@/utils";
import store from "@/store";

if (!utils.isDev) {
  // require("firebase/messaging");
}

firebase.initializeApp(config.firebase.config);

const firestore = firebase.firestore();
const analytics = firebase.analytics();
const storage = firebase.storage();
const auth = firebase.auth();
const functions = firebase.functions();
const remoteConfig = firebase.remoteConfig();
const database = firebase.database();

if (!utils.isDev) {
  // const messaging = firebase.messaging()
  // messaging.getToken({ vapidKey: config.firebase.messagingKey })
}

const getCustomClaimRole = async function() {
  await firebase.auth().currentUser.getIdToken(true);
  const decodedToken = await firebase.auth().currentUser.getIdTokenResult();
  return decodedToken.claims.stripeRole;
};

auth.useDeviceLanguage();
auth.onAuthStateChanged((user) => {
  if (user == null) {
    store.commit("logOut");
  } else {
    store.commit("logIn", user);
  }
});

if (utils.isDev) {
  remoteConfig.settings = {
    minimumFetchIntervalMillis: 0,
  };

  if (process.env.VUE_APP_LOCAL_FUNCTIONS === "true") {
    functions.useFunctionsEmulator("http://localhost:5001");
  }
} else {
  remoteConfig.settings = {
    minimumFetchIntervalMillis: config.firebase.remoteFetchIntervalMillis,
  };
}

let isFirstWait = true;
const waitFirstAuth = () => {
  return new Promise((resolve) => {
    if (!isFirstWait) {
      resolve();
      return;
    }

    auth.onAuthStateChanged(() => {
      isFirstWait = false;
      resolve();
    });
  });
};

const loginWithProvider = async (provider) => {
  await auth.signInWithRedirect(provider);
};

export default {
  getCustomClaimRole,
  loginWithProvider,
  analytics,
  firebase,
  firestore,
  auth,
  remoteConfig,
  functions,
  database,
  storage,
  Timestamp: firebase.firestore.Timestamp,
  FieldValue: firebase.firestore.FieldValue,
  waitFirstAuth,
};
